import React from 'react'
import Barcode from 'react-barcode';



const BarcodeInput = ({name,itemcode}) => {
  return (
    <>
    <div className="barcode-container text-center" style={{marginTop:"2px"}}>
      <div className="barcode mt-0">
      <Barcode value={itemcode} margin={0} textMargin={1} fontSize={15} />
      </div>
      {/* Title */}
      <h6 className="text-md font-bold" style={{marginBottom: "0px",fontSize:"10px"}}>Flash Health</h6>
      
    </div>
    </>
  )
}

export default BarcodeInput